@let appt = appointment;
@let slot = appt.confirmedSlot;

<div class="flex flex-col gap-5 max-w-lg">
  <!-- DIALOG HEADER -->
  <div class="flex items-start justify-between gap-4">
    <div class="flex items-center gap-3">
      <div
        class="flex size-11 items-center justify-center rounded-2xl bg-indigo-3 text-indigo-11 border border-indigo-4 shrink-0"
      >
        <mat-icon class="size-6 !text-2xl">event</mat-icon>
      </div>
      <div>
        <h2 class="text-lg font-bold text-neutral-12 m-0 leading-tight">Détails de la visite</h2>
        <p class="text-xs text-neutral-10 m-0 mt-0.5">
          Rendez-vous planifié sur le bien
          @if (property?.definition?.reference; as ref) {
            <span class="font-mono text-neutral-11">(Réf. {{ ref }})</span>
          }
        </p>
      </div>
    </div>

    <button
      mat-icon-button
      (click)="close()"
      class="!text-neutral-10 hover:!text-neutral-12 -mt-1 -mr-1"
      aria-label="Fermer"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- MAIN VISIT INFO CARD -->
  <div class="p-4 rounded-2xl bg-neutral-2 border border-neutral-3 flex flex-col gap-3.5">
    <!-- Status & Date -->
    <div class="flex flex-col gap-1">
      <div class="flex items-center gap-2">
        <span
          class="px-2 py-0.5 text-xs font-semibold rounded-md border"
          [class.bg-indigo-3]="slot"
          [class.text-indigo-11]="slot"
          [class.border-indigo-4]="slot"
          [class.bg-amber-3]="!slot"
          [class.text-amber-11]="!slot"
          [class.border-amber-4]="!slot"
        >
          {{ slot ? 'Visite confirmée' : 'En attente de confirmation' }}
        </span>
      </div>

      <div class="text-base font-bold text-neutral-12 mt-1">
        @if (slot) {
          {{ slot.startAt | luxonDate: 'EEEE d MMMM yyyy à HH:mm' }}
        } @else {
          Créneaux proposés à valider avec le propriétaire
        }
      </div>
    </div>

    <!-- Location -->
    <div class="flex items-start gap-2 text-xs text-neutral-11 pt-2 border-t border-neutral-3">
      <mat-icon class="!text-sm size-4 text-neutral-9 mt-0.5">place</mat-icon>
      <div>
        <span class="font-semibold text-neutral-12">Lieu du rendez-vous :</span>
        <div class="text-neutral-11 mt-0.5">
          @if (appt.location?.address; as addr) {
            {{ addr }}
          } @else if (property?.location?.address?.city; as city) {
            {{ city }}
          } @else {
            Adresse transmise avant la visite
          }
        </div>
      </div>
    </div>

    <!-- Organizer / Seller -->
    @if (appt.organizerName; as org) {
      <div class="flex items-center gap-2 text-xs text-neutral-11 pt-2 border-t border-neutral-3">
        <mat-icon class="!text-sm size-4 text-neutral-9">person</mat-icon>
        <span
          >Organisé avec : <strong class="text-neutral-12">{{ org }}</strong></span
        >
      </div>
    }

    <!-- Notes if any -->
    @if (appt.notes; as notes) {
      <div class="p-3 rounded-xl bg-neutral-1 border border-neutral-3 text-xs text-neutral-11 italic">
        « {{ notes }} »
      </div>
    }
  </div>

  <!-- ACTIONS -->
  <div class="flex flex-col sm:flex-row items-center justify-end gap-2.5 pt-2">
    <button
      mat-stroked-button
      class="w-full sm:w-auto !py-3.5 !px-4 font-semibold text-xs !border-neutral-4"
      (click)="openAgenda()"
    >
      <mat-icon class="!text-sm size-4 text-neutral-11 mr-1">calendar_month</mat-icon>
      <span>Voir dans mon agenda</span>
    </button>

    <button
      mat-flat-button
      class="primary w-full sm:w-auto !py-3.5 !px-5 font-bold text-xs"
      (click)="openDiscussion()"
    >
      <mat-icon class="!text-sm size-4 mr-1">chat</mat-icon>
      <span>Accéder à la messagerie</span>
    </button>
  </div>
</div>
